<template>
  <b-container fluid class="meet-your-side-kicks">
    <b-row class="h-100">
      <b-col>
        <div class="meet-content">
          <img
            src="@/assets/rebrand/home/meet-your-side-kicks.png"
            alt="meet your Side Kicks title"
            class="meet-your-side-kicks-title"
          />
          <div class="title-divider">
            <span class="-wb" />
          </div>
          <h5 class="title">The Rise of A New Hero</h5>
          <p class="desc -wb">
            The survival of Sneaker Culture depends on a few, brave animal <br />
            companions called Side Kicks. Side Kicks undergo rigorous physical <br />
            conditioning and specialized sneaker training powered by SNKRHUD. <br />Each Faction has
            a particular set of skills that allows them to rebuild <br />critical infrastructures,
            collect sneaker pieces, pilot Box Bots, and <br />establish secure communication lines
            with Collectors (YOU) and other <br />
            Factions through the SNKRHUD App.
          </p>

          <p class="desc -mb">
            The survival of Sneaker Culture depends <br />
            on a few, brave animal companions called <br />
            Side Kicks. Side Kicks undergo rigorous <br />physical conditioning and specialized
            <br />sneaker training powered by SNKRHUD. <br />Each Faction has a particular set of
            <br />skills that allows them to rebuild critical<br />
            infrastructures, collect sneaker pieces, <br />pilot Box Bots, and establish secure<br />
            communication lines with Collectors (YOU) <br />and other Factions through the SNKRHUD
            App.
          </p>
          <div class="nft-right-element">
            <span class="top-left" />
            <span class="left-bottom" />
            <span class="top-triangle" />
            <span class="nft-dot1" />
            <span class="nft-dot2" />
          </div>
          <div class="bottom-wht-divider">
            <span class="top-wht -wb" />
            <span class="bottom-wht -wb" />
          </div>
        </div>

        <div class="sneaker-gear-content">
          <span>
            <h5 class="title">
              Powerful <br />
              Sneaker Gear
            </h5>
            <p class="desc -wb">
              To increase their performance and <br />withstand harsh conditions, Side Kicks
              <br />outfit their bodies with iconic sneaker <br />pieces that they obtain from
              nearby <br />black-ops Sneaker Drop Sites and <br />hidden Sneaker Vaults.
            </p>

            <p class="desc -mb">
              To increase their performance and withstand <br />harsh conditions, Side Kicks outfit
              their <br />bodies with iconic sneaker pieces that they <br />obtain from nearby
              black-ops Sneaker Drop <br />Sites and hidden Sneaker Vaults.
            </p>
          </span>
          <div class="gears-content">
            <span class="violet-divider" />
            <span class="orange-divider -mb" />
            <figure class="gear-bg">
              <img src="@/assets/rebrand/home/rudi.png" alt="helmet" class="img-gears" />
              <div class="orange-border" />
              <span class="circle-shape -wb" />
              <span class="arrow-up -wb" />
            </figure>

            <figure class="gear-bg">
              <img src="@/assets/rebrand/home/shoe-lace.png" alt="helmet" class="img-gears" />
              <div class="orange-border" />
              <span class="circle-shape -wb" />
              <span class="arrow-up -wb" />
            </figure>

            <figure class="gear-bg">
              <img src="@/assets/rebrand/home/helmet.png" alt="helmet" class="img-gears" />
              <div class="orange-border" />
              <span class="circle-shape -wb" />
              <span class="arrow-up -wb" />
            </figure>
          </div>
          <img src="@/assets/rebrand/home/element-1.png" alt="elements" class="element-1 -wb" />
        </div>

        <div class="operation-4280-content">
          <span>
            <h1 class="title">
              Operation <br />
              <b>4280</b>
            </h1>
          </span>
          <div class="operation-content">
            <h5 class="title -wb">
              SIDE KICK <br />
              TRAITS
            </h5>
            <h5 class="title-desc -mb">
              SIDE KICK TRAITS
            </h5>
            <!-- <figure class="gear-bg">
                <div class="orange-border" />
              </figure> -->
            <p class="desc-operation">
              <b>8 Unique Rarity Attributes</b>
              including Background Environments, Fur Types, Facial Expressions, Masks, Neck Scarfs,
              Body Armor, Battle Wraps, and Tail Tools
            </p>
            <p class="desc-operation">
              <b>100+ hand drawn retro future pieces</b>
              inspired by your favorite sneaker & streetwear labels
            </p>
            <p class="desc-operation">
              <b>100M+ possible style combinations </b>
            </p>
          </div>
          <img
            src="@/assets/rebrand/home/operation-4280-bg.png"
            alt="operation 4280"
            class="operation-4280-bg -wb"
          />
          <img
            src="@/assets/mobile/operation-4280-bg-mobile.png"
            alt=""
            class="operation-4280-bg -mb"
          />
        </div>
      </b-col>
    </b-row>

    <!-- <img src="@/assets/mobile/operation.png" alt="operation 4280" class="operation-4280-bg -mb" />
    <img src="@/assets/mobile/txt-divider.png" alt="divider" class="txt-divider -mb" />
    <img src="@/assets/mobile/traits-icon.png" alt="traits icon" class="traits-icon -mb" />-->

    <img
      src="@/assets/rebrand/home/orange-soldier.png"
      alt="orange soldier"
      class="img-orange-soldier"
    />
    <img
      src="@/assets/rebrand/home/violet-soldier.png"
      alt="violet soldier"
      class="img-violet-soldier"
    />
    <img
      src="@/assets/rebrand/home/meet-your-side-kicks-bg.png"
      alt="meet bg"
      class="meet-bg -wb"
    />
    <img src="@/assets/mobile/bg-sidekick.png" alt="meet bg" class="meet-bg -mb" />
    <img
      src="@/assets/rebrand/home/meet-your-side-kicks-overlay.png"
      alt="meet your Side Kicks"
      class="img-side-kicks-1"
    />

    <img
      src="@/assets/rebrand/home/sneaker-gear-bg.png"
      alt="sneaker gear"
      class="sneaker-gear-bg -wb"
    />
    <img src="@/assets/mobile/sidekick-grid.png" alt="sneaker gear" class="sneaker-gear-bg -mb" />
    <img src="@/assets/mobile/rarity-shape1.png" alt="rarity shape" class="rarity-shape1 -mb" />
    <div class="sneaker-gear-bg" />
  </b-container>
</template>
<script>
export default {
  name: 'MeetYourSideKick',
};
</script>
